export default "__VITE_PUBLIC_ASSET__870ce130__"